import React from 'react';
import PropTypes from 'prop-types';
import {ZoomInIcon, ZoomOutIcon} from './Icons';
import {ZoomDropdown} from './ZoomDropdown';
import './style.scss';
import i18next from 'i18next';
import { useTranslation } from "react-i18next";

// Import suppoted languages (Add to conditional use statement)
import UI_ar from "./locales/ar/translation.json";
import UI_de from "./locales/de/translation.json";
import UI_en from "./locales/en/translation.json";
import UI_es from "./locales/es/translation.json";
import UI_fr from "./locales/fr/translation.json";
import UI_it from "./locales/it/translation.json";
import UI_ja from "./locales/ja/translation.json";
import UI_ko from "./locales/ko/translation.json";
import UI_nl from "./locales/nl/translation.json";
import UI_pt from "./locales/pt/translation.json";
import UI_tr from "./locales/tr/translation.json";
import UI_zh from "./locales/zh/translation.json";
import UI_zu from "./locales/zu/translation.json";
import UI_uk from "./locales/uk/translation.json";

const ENTER_KEY = 13;
/**
 * ZoomMenu:
 *  - Component renders the ZoomIn/Out Controls for PopupZoomImage component
 */
export function ZoomMenu(props) {

  const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let currentLang = urlParams.get('lng');
    if(currentLang === null){
      currentLang = "en";
    }

    i18next.addResourceBundle('en', 'translation', ( // Supported languages used
      currentLang == "ar" ? UI_ar
      : currentLang == "de" ? UI_de
      : currentLang == "en" ? UI_en
      : currentLang == "es" ? UI_es
      : currentLang == "fr" ? UI_fr
      : currentLang == "it" ? UI_it
      : currentLang == "ja" ? UI_ja
      : currentLang == "ko" ? UI_ko
      : currentLang == "nl" ? UI_nl
      : currentLang == "pt" ? UI_pt
      : currentLang == "tr" ? UI_tr
      : currentLang == "zh" ? UI_zh
      : currentLang == "uk" ? UI_uk
      : currentLang == "zu" ? UI_zu // Add language support by importing the file above and adding a new line here: ": currentlang == lang ? UI_lang"
      : UI_en
    ), true, true);

    const { 
      t
      // i18n 
    } = useTranslation("translation");

  const onDropdownChange = (option) => props.setZoom(option.value);

  const zoomIN = () => props.setZoom(props.zoomValue + props.zoomRate);

  const zoomOUT = () => props.setZoom(props.zoomValue - props.zoomRate);

  const zoomOutDisabled = () => {
    if (props.zoomValue <= props.minZoom) {
      return true;
    } else {
      return false;
    }
  };

  const zoomInDisabled = () => {
    if (props.zoomValue >= props.maxZoom) {
      return true;
    } else {
      return false;
    }
  };

  const className = `zoomMenuBlock ${props.className}`;

  return (
    <div id="zoomMenu" aria-label="Zoom menu" role="form" className={className}>
      <button
        tabIndex='0'
        aria-label={t("ZoomIn.string")}
        className={'zoomMenuBlock_left'}
        disabled={zoomInDisabled()}
        onClick={zoomIN}>
        <ZoomInIcon className='icon icon-zoomIn' />
      </button>
      <div
        className='zoomMenuBlock_middle'
      >
        <ZoomDropdown
          ariaLabel={`Current zoom value is ${props.zoomValue * 100} percent`}
          value={props.zoomValue}
          options={props.dropdownOptions}
          onChange={onDropdownChange}
        />
      </div>
      <button
        tabIndex='0'
        aria-label={t("ZoomOut.string")}
        className={'zoomMenuBlock_right'}
        disabled={zoomOutDisabled()}
        onClick={zoomOUT}>
        <ZoomOutIcon className='icon icon-zoomOut' />
      </button>
    </div>
  );
}

ZoomMenu.propTypes = {
  /**
   * className to set on component
   */
  className: PropTypes.string,
  /**
   * Function to set the zoom value
   */
  setZoom: PropTypes.func,
  /**
   * Current zoom value
   */
  zoomValue: PropTypes.number,
  /**
   * Rate at which zoom needs be increased /decreased
   */
  zoomRate: PropTypes.number,
  /**
   * max value for zoom
   */
  maxZoom: PropTypes.number,
  /**
   * min value for zoom
   */
  minZoom: PropTypes.number,
  /**
   * Option to show on dropdown
   */
  dropdownOptions: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * value of the dropdown option
       */
      value: PropTypes.number,
      /**
       * Label of options
       */
      label: PropTypes.string,
    })
  ),
};

ZoomMenu.defaultProps = {
  className: '',
};
